export default "__VITE_ASSET__uiPyHzEZ__"